import { object, string } from 'yup'

import { validateField, validateValues } from 'shared/utils/form'

export interface PaymentFormValues {
  blikCode: string
}

const blikSchema = object().shape({
  blikCode: string()
    .required('Kod blik jest wymagany')
    .matches(/^\d{6}$/, {
      message: 'Podany kod jest nieprawidłowy. Kod BLIK musi zawierać 6 cyfr'
    })
})

export const validateBlikFormField = (values: PaymentFormValues) =>
  validateField(blikSchema, values)

export const validateBlikFormValues = validateValues(blikSchema)
